export default function MagnifyingGlassIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="ostro-magnifying-glass-icon"
    >
      <path
        d="M18.15 19C17.9 19 17.7 18.9 17.55 18.75L14.1 15.3C13.15 16 11.95 16.4 10.75 16.4C7.55 16.4 5 13.8 5 10.7C5 7.6 7.55 5 10.7 5C13.85 5 16.4 7.55 16.4 10.7C16.4 11.9 16 13.1 15.3 14.05L18.75 17.5C18.9 17.65 19 17.9 19 18.1C19 18.3 18.9 18.55 18.75 18.7C18.6 18.85 18.35 19 18.15 19ZM10.7 6.75C8.5 6.75 6.75 8.5 6.75 10.7C6.75 12.9 8.5 14.65 10.7 14.65C12.85 14.65 14.65 12.9 14.65 10.7C14.65 8.5 12.85 6.75 10.7 6.75Z"
        fill="#1E1E1E"
      />
    </svg>
  );
}
